import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "add-to-list__list" }
const _hoisted_2 = { class: "add-to-list__controls" }

import { onBeforeUnmount, ref } from 'vue'

import { DocCustomListsView } from '@/models/doc.custom.lists'
import { PublicInterface } from '@/models/interfaces'

import BasePopup from '@/components/ui/BasePopup.vue'
import CircleSpinner from '@/components/ui/CircleSpinner.vue'
import LoadingError from '@/components/ui/LoadingError.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import CustomListForm from '../custom.lists/CustomListForm.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import { CreateCustomListForm } from '@/models/custom.lists'


export default /*@__PURE__*/_defineComponent({
  __name: 'AddToListPopup',
  props: {
    view: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const basePopup = ref<InstanceType<typeof BasePopup> | null>(null)
const customListForm = ref<InstanceType<typeof CustomListForm> | null>(null)

const formView = ref(new CreateCustomListForm(props.view))

async function show(): Promise<void> {
  if (!basePopup.value) {
    return
  }

  basePopup.value.show()
  await props.view.getLists()
}

/**
 * Show the "Create New List" popup
 * and hide this one.
 */
function showCreateList(): void {
  basePopup.value?.hide()
  customListForm.value?.show()
}

onBeforeUnmount(async () => {
  await props.view.clearState()
})

__expose({
  show,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BasePopup, {
      ref_key: "basePopup",
      ref: basePopup,
      title: "Add to...",
      class: "add-to-list",
      compact: true,
      onHide: _cache[1] || (_cache[1] = ($event: any) => (__props.view.clearState()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_wait, { for: "Error Loading Lists" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingError, { class: "add-to-list__error" })
          ]),
          _: 1
        }),
        _createVNode(_component_v_wait, { for: "Loading Lists" }, {
          waiting: _withCtx(() => [
            _createVNode(CircleSpinner, {
              class: "add-to-list__spinner",
              color: "#ffc906",
              size: 36
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.lists, (list) => {
                return (_openBlock(), _createBlock(ToggleButton, {
                  key: list.id,
                  type: "checkbox",
                  class: "add-to-list__input",
                  value: __props.view.listsState[list.url_slug],
                  "onUpdate:value": (updatedValue) => __props.view.toggleList(list, updatedValue)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(list.title), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AppButton, {
                class: "add-to-list__btn add-to-list__btn--new",
                icon: "iadd",
                outlined: true,
                onClick: showCreateList
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("New List", -1)
                ]))]),
                _: 1
              }),
              _createVNode(AppButton, {
                class: "add-to-list__btn add-to-list__btn--done",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (basePopup.value?.hide()))
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Done", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createVNode(CustomListForm, {
      ref_key: "customListForm",
      ref: customListForm,
      view: formView.value
    }, null, 8, ["view"])
  ], 64))
}
}

})